import { createContext, useContext } from "react";
export const SofiaMagicStudioContext = createContext();

const _limit = 50;

export const SofiaMagicStudioProvider = ({ children }) => {
  
  return (
    <SofiaMagicStudioContext.Provider
      value={{}}
    >
      {children}
    </SofiaMagicStudioContext.Provider>
  );
};

export const useSofiaMagicStudioCtx = () => {
  const ctx = useContext(SofiaMagicStudioContext);

  if (!ctx) {
    throw new Error(
      "useSofiaMagicStudioCtx must be used within the SofiaMagicStudioProvider"
    );
  }

  return ctx;
};
